import React from 'react';
import GrantScreeningDashboard from './GrantScreeningDashboard';

function App() {
  return (
    <div className="App">
      <GrantScreeningDashboard />
    </div>
  );
}

export default App;